import { Button } from "react-bootstrap";
import "./Button.css";

export default function ButtonComponent({ onClick, label, style, className, testId, disabled = false }) {
  return (
    <div className={`custom-button ${className}`}>
      <Button className="btn-w color3" onClick={onClick} style={style} data-testid={testId} disabled={disabled}>
        {label}
      </Button>
    </div>
  );
}
